export const Uzda = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.955272473835635, 53.53464961517466],
            [26.95545465952955, 53.53444750358426],
            [26.958311563542793, 53.52850419088168],
            [26.956597420775495, 53.52086156330677],
            [26.954026207972163, 53.503363246933816],
            [26.95374051766055, 53.499284931204784],
            [26.949455162988215, 53.49520622367203],
            [26.945455497728915, 53.489257404670525],
            [26.942884284925526, 53.481267677519725],
            [26.941741523679582, 53.47174603855245],
            [26.94259859461397, 53.46528370935965],
            [26.944884117105914, 53.45933069353498],
            [26.952597756414548, 53.455248142921846],
            [26.958597253854236, 53.45048467119011],
            [26.961454156969353, 53.44708186464709],
            [26.958025873231406, 53.44299813641669],
            [26.954026207972163, 53.43959472958727],
            [26.953454827349162, 53.43636124108417],
            [26.955740349841108, 53.431595651103066],
            [26.948312401742214, 53.42904243693209],
            [26.93888462056458, 53.42989352536347],
            [26.933456503747948, 53.432276482313114],
            [26.927171316895, 53.43329770867933],
            [26.918600606651978, 53.43295730261707],
            [26.910886967343345, 53.43057438383903],
            [26.907744373917012, 53.427340208410044],
            [26.906030231149714, 53.424786738617854],
            [26.900316424919765, 53.421381873103314],
            [26.889745882496186, 53.41797673544153],
            [26.882032243187552, 53.412698232618595],
            [26.880032411007164, 53.40792998945756],
            [26.880032411007164, 53.40469409182384],
            [26.877461198203775, 53.39890292329687],
            [26.874032913567532, 53.39617739449159],
            [26.868319107337584, 53.39396277423691],
            [26.864605132389897, 53.39191840656531],
            [26.86374806145534, 53.3888516717426],
            [26.867747726714583, 53.38544392893306],
            [26.87546136512492, 53.384421553058075],
            [26.884603455991112, 53.38305834703448],
            [26.890031572807743, 53.38135427812625],
            [26.893459856545746, 53.37879804635406],
            [26.89517399841452, 53.37402600413827],
            [26.89517399841452, 53.37315782810555],
            [26.901882007898564, 53.37110797748153],
            [26.90919568041187, 53.36772608901697],
            [26.916143669434234, 53.364998563781796],
            [26.927845545634852, 53.35943387169135],
            [26.942107207170523, 53.35244970011945],
            [26.95746592007714, 53.345027763373935],
            [26.966973694434103, 53.34087964786755],
            [26.980138304598597, 53.33301895426996],
            [26.98544071746261, 53.330398400929596],
            [26.99366859915233, 53.328105284830144],
            [26.998239645034403, 53.328978867095486],
            [27.000982271665464, 53.33061678643412],
            [27.004090582685762, 53.33367406718287],
            [27.008478786373303, 53.33465671795534],
            [27.012318464375312, 53.33465671795534],
            [27.016706668062852, 53.334001620134586],
            [27.019997820379388, 53.33159950763741],
            [27.024020340576158, 53.329088063888946],
            [27.026945809401752, 53.326576472286376],
            [27.031882538774937, 53.32275420071278],
            [27.034990849795065, 53.320897545904074],
            [27.038647685602598, 53.32046067373574],
            [27.043218731484842, 53.32067911064735],
            [27.05016672050698, 53.32242656193199],
            [27.057114709529344, 53.32406473228906],
            [27.061137228827818, 53.3259212498337],
            [27.064611223338886, 53.328105284830144],
            [27.067536693062948, 53.33072597903521],
            [27.071010687574017, 53.334329170570754],
            [27.074850365576083, 53.33782288359453],
            [27.078141517892618, 53.340006309310525],
            [27.080701303227215, 53.34142547565119],
            [27.08618655828593, 53.341207145483395],
            [27.090940445464412, 53.34033381363355],
            [27.09642569962483, 53.337932057749924],
            [27.102642321665257, 53.33684030576603],
            [27.107030525352968, 53.33749536052471],
            [27.110321677669504, 53.33978797187666],
            [27.111601570336745, 53.341643804701164],
            [27.11489272265328, 53.34470029563727],
            [27.119463768535525, 53.346228458677786],
            [27.124217655714006, 53.34644676313587],
            [27.129154384188723, 53.346774217995176],
            [27.133359746580027, 53.34764741794254],
            [27.1373822658785, 53.349393765256934],
            [27.145061622780872, 53.35124918002458],
            [27.14963266776482, 53.3510309001573],
            [27.153838029257827, 53.34841145349384],
            [27.1543865549433, 53.34186213316951],
            [27.15365518796159, 53.33869626740284],
            [27.15402087145236, 53.33312814018592],
            [27.15493508062883, 53.329088063888946],
            [27.15950612561278, 53.32526601785514],
            [27.165722747653206, 53.3218804909917],
            [27.182909878014414, 53.31303316902489],
            [27.196257331271738, 53.30571362777641],
            [27.209970467121707, 53.299267022643164],
            [27.22423212865715, 53.29828355674795],
            [27.2330085360324, 53.29861138140819],
            [27.240687892036647, 53.300141195836545],
            [27.247453038864307, 53.302108019428715],
            [27.25696081322127, 53.302872870866565],
            [27.263543118752636, 53.304074752974714],
            [27.279267515150252, 53.30953742561445],
            [27.285118453699738, 53.31467170051036],
            [27.290420865665396, 53.31838547160419],
            [27.294077702371226, 53.322208134501864],
            [27.2977345381787, 53.325484429632695],
            [27.30523105288654, 53.32745008585573],
            [27.311081991436026, 53.32679487735584],
            [27.316201562105448, 53.32526601785514],
            [27.3218696584604, 53.323409471800346],
            [27.327903438306294, 53.320897545904074],
            [27.334668585133898, 53.3193684750899],
            [27.341068048470788, 53.317948574256036],
            [27.352404241180636, 53.3175116724355],
            [27.37196831558026, 53.31674708321924],
            [27.392812282647128, 53.31707476560587],
            [27.411644990064815, 53.31816702348914],
            [27.42005571305083, 53.31696553860206],
            [27.4206001129765, 53.316260876558886],
            [27.422748769746136, 53.318944694155675],
            [27.425453203604548, 53.32229987397619],
            [27.43086207042296, 53.32602754217646],
            [27.43793520464584, 53.32813974329463],
            [27.443552105114463, 53.32938216512639],
            [27.452705573143533, 53.33149420016832],
            [27.45603410705405, 53.332363830759164],
            [27.45894657366415, 53.33472416843148],
            [27.460194773768308, 53.33807810756167],
            [27.459986740118097, 53.34081075202829],
            [27.457698373560163, 53.34354322139512],
            [27.45395377324769, 53.34590293988293],
            [27.452705573143533, 53.34913181755928],
            [27.45395377324769, 53.35136705091344],
            [27.457698373560163, 53.35273296897617],
            [27.462275107574726, 53.35434717973749],
            [27.464979540534785, 53.35683046162234],
            [27.466435774288982, 53.36192073625347],
            [27.46789200804335, 53.36564494236944],
            [27.472052674757606, 53.36787930979153],
            [27.477669575226116, 53.36787930979153],
            [27.483078442942997, 53.36775518169969],
            [27.486615009605316, 53.365148400719136],
            [27.48931944346367, 53.36130000376477],
            [27.49035960991762, 53.35695462154325],
            [27.493480110177927, 53.352112102652825],
            [27.50013717799885, 53.34826252831266],
            [27.50908261237788, 53.34689646700008],
            [27.513451312742347, 53.34739322187659],
            [27.517611979456774, 53.34925600044369],
            [27.520316413315186, 53.35248462363916],
            [27.519900346913232, 53.356457978617016],
            [27.517820013106814, 53.3593135982847],
            [27.51178704533794, 53.36452771471431],
            [27.508666545077574, 53.367631052710124],
            [27.503673744661114, 53.37098240365731],
            [27.502217511805213, 53.37507814121511],
            [27.50804244502558, 53.3779325136357],
            [27.51220311263819, 53.37830480893126],
            [27.51927624686101, 53.376691505631925],
            [27.52302084717354, 53.37358882767154],
            [27.52759758028975, 53.369989438449466],
            [27.5309261142001, 53.36663800938152],
            [27.53363054805851, 53.36353459904922],
            [27.53862334847514, 53.359561903832514],
            [27.540703682281503, 53.35620965444741],
            [27.545904515449763, 53.35322965584521],
            [27.55360174972475, 53.35298131340227],
            [27.557138317285364, 53.35372633692657],
            [27.56109095034958, 53.355837166016386],
            [27.5683721182225, 53.3575754178666],
            [27.57502918514507, 53.35608549235633],
            [27.581686252965994, 53.35397467502901],
            [27.589799553642763, 53.35149122728643],
            [27.595208420461233, 53.34913181755928],
            [27.601424217379986, 53.34506209942987],
            [27.606026154996584, 53.3453673577626],
            [27.61285224982123, 53.34594951243622],
            [27.61740297940497, 53.348472090658106],
            [27.620328448230737, 53.35215866788718],
            [27.622278760781114, 53.35681494140556],
            [27.620653500921264, 53.36050079712862],
            [27.617728031197373, 53.36399236604706],
            [27.615777718646996, 53.36922918352434],
            [27.614802562371608, 53.374271436087554],
            [27.615452666854594, 53.378537491503494],
            [27.61935329195535, 53.3829970019728],
            [27.625529282297293, 53.3845480259688],
            [27.635605897739936, 53.38338476300106],
            [27.641781888081823, 53.38241535273772],
            [27.64763282663148, 53.38241535273772],
            [27.656409233108263, 53.38338476300106],
            [27.660959962692004, 53.38435415119318],
            [27.665510692275745, 53.38726218334449],
            [27.667135953033892, 53.39094540473138],
            [27.664210484208297, 53.39424064934724],
            [27.659984806416787, 53.39617890876292],
            [27.654458920557886, 53.397341822148235],
            [27.645032409598173, 53.39966755412132],
            [27.639611059790468, 53.400805255257126],
            [27.63641566788317, 53.40374223909174],
            [27.63561681945714, 53.40755207820331],
            [27.638679070259627, 53.40921877569724],
            [27.646667551824407, 53.40985369074616],
            [27.65146063968524, 53.41152029806142],
            [27.653990325169616, 53.41453589723125],
            [27.654389749382574, 53.41763063234316],
            [27.654389749382574, 53.42096317169256],
            [27.653457759851904, 53.42481609475578],
            [27.649921193189584, 53.42630361644916],
            [27.64430429272096, 53.42816294537238],
            [27.639935592356494, 53.42989824601756],
            [27.63535885834193, 53.43274894252187],
            [27.63369459183582, 53.43597123933523],
            [27.634110658237773, 53.43906937055419],
            [27.64243199256481, 53.44363870289283],
            [27.64925808649116, 53.445768308335744],
            [27.65348376428267, 53.446155497466634],
            [27.656084181316032, 53.446155497466634],
            [27.661779094178712, 53.445760564431566],
            [27.665939761791492, 53.444769342667314],
            [27.66697992824544, 53.44018464262655],
            [27.66573172814128, 53.43721051871444],
            [27.66573172814128, 53.43361650808845],
            [27.668228128349597, 53.43138558988039],
            [27.674261095220004, 53.43039403273133],
            [27.681334229443053, 53.43126164636806],
            [27.68861539731597, 53.43274894252187],
            [27.69464836418655, 53.43349257108184],
            [27.702761664863374, 53.43299682051111],
            [27.70962676633428, 53.43150953303143],
            [27.71337136664681, 53.43064192445479],
            [27.720236467219422, 53.43002219297057],
            [27.726477467740096, 53.43101375879411],
            [27.73022206805257, 53.43312075842829],
            [27.73230240185876, 53.43820191683841],
            [27.733134534662668, 53.44253900993726],
            [27.732926501910924, 53.44625616610557],
            [27.734382734766825, 53.44960132857864],
            [27.736671102223283, 53.451707407194306],
            [27.73563093487104, 53.45666247368973],
            [27.731678301806767, 53.458272745405],
            [27.723356967479788, 53.45864433798039],
            [27.715451699554706, 53.45852047450643],
            [27.708170532580084, 53.45765341739764],
            [27.70442593226778, 53.45678634258371],
            [27.699849198253105, 53.45406113596158],
            [27.69839296449885, 53.45232682192341],
            [27.695272464238542, 53.45034466224189],
            [27.691111797524286, 53.448114622224864],
            [27.68445472970336, 53.448981874100014],
            [27.678421762832784, 53.45207905722293],
            [27.678213729182573, 53.455671506321664],
            [27.67946192928673, 53.45913978986721],
            [27.680502096639145, 53.46260779013369],
            [27.677173562728626, 53.466570871768624],
            [27.670724528557912, 53.467809259140495],
            [27.663235327933137, 53.466323190172716],
            [27.659074660320357, 53.46496091475967],
            [27.654289893554107, 53.46471322323515],
            [27.648464959435387, 53.466323190172716],
            [27.645136426423164, 53.468923776724125],
            [27.643472159018756, 53.473381554419404],
            [27.640559692408658, 53.47684839132745],
            [27.637023124848042, 53.479200726555916],
            [27.626829490364855, 53.48217191074207],
            [27.61954832339012, 53.48217191074207],
            [27.61205912276546, 53.47994354210948],
            [27.60893862250498, 53.4782102852314],
            [27.60165745463206, 53.47523882360497],
            [27.595416454111444, 53.47177185573037],
            [27.58938348724081, 53.46805693206551],
            [27.583766586772356, 53.465456292403644],
            [27.57731755260147, 53.46359859509408],
            [27.571492618482807, 53.46335089615559],
            [27.565459651612173, 53.465456292403644],
            [27.565667684364087, 53.46830460407995],
            [27.57024441837865, 53.472143330160065],
            [27.574197052341162, 53.47474356012634],
            [27.576277385249227, 53.47981974024225],
            [27.57544525244532, 53.4822957057458],
            [27.571284584832597, 53.48291467427697],
            [27.567748018170278, 53.48254329413504],
            [27.55838651738935, 53.479200726555916],
            [27.5554740498809, 53.47721982132123],
            [27.55256158327063, 53.47622933429068],
            [27.548400916556375, 53.47598170851961],
            [27.546112549099973, 53.47808647884102],
            [27.54569648269802, 53.48093394243995],
            [27.548400916556375, 53.484152584781214],
            [27.551313383166644, 53.486875859990676],
            [27.5554740498809, 53.492816945827656],
            [27.56317128415577, 53.50024213218694],
            [27.571245579084632, 53.507673750958645],
            [27.577096516735992, 53.51134654664793],
            [27.57839672570168, 53.516758507371776],
            [27.57839672570168, 53.523522486583715],
            [27.57904682928637, 53.53260384543046],
            [27.5796969337693, 53.53704720490322],
            [27.58294745528542, 53.54458053167269],
            [27.586848080386403, 53.547091342876286],
            [27.59237396624536, 53.55056760431802],
            [27.600175217345225, 53.55230562796248],
            [27.606026154996584, 53.55230562796248],
            [27.614477510579377, 53.55385047812047],
            [27.61837813568019, 53.55597455493074],
            [27.61935329195535, 53.559643163775036],
            [27.616102771337523, 53.5623461455981],
            [27.610251832787867, 53.56408368545425],
            [27.605376051411895, 53.56485590283603],
            [27.59757480031203, 53.56659333959777],
            [27.59724974851963, 53.56813766809131],
            [27.601150373620385, 53.57026102762717],
            [27.604725946928966, 53.57199824234857],
            [27.60765141575473, 53.573542373476585],
            [27.60862657202972, 53.57450742686365],
            [27.60862657202972, 53.57720945884779],
            [27.606351207687112, 53.579332362874595],
            [27.602775634378588, 53.57991131815032],
            [27.59887500837948, 53.58010430130241],
            [27.596274592244413, 53.58106920491474],
            [27.595299435070956, 53.5835778511244],
            [27.596274592244413, 53.58531451873057],
            [27.59724974851963, 53.5870511149796],
            [27.596924695829102, 53.589752345270085],
            [27.596274592244413, 53.59148875970135],
            [27.593674175211106, 53.59303217899878],
            [27.589773549211998, 53.593610946634044],
            [27.582297350802662, 53.592260476130605],
            [27.579371881977067, 53.59013822136933],
            [27.57742156942652, 53.587437015744456],
            [27.576771464943704, 53.58589339207538],
            [27.576446413151473, 53.58319191512146],
            [27.575146204185558, 53.580683246006174],
            [27.57384599611794, 53.578946388107966],
            [27.570595474601816, 53.57701646248046],
            [27.56669484950089, 53.576244467134075],
            [27.562794223501783, 53.576437467558776],
            [27.556293181367664, 53.57875339966989],
            [27.549792139233546, 53.58222705996354],
            [27.545891514132734, 53.58550747774859],
            [27.541990888133455, 53.58801586001829],
            [27.54036562737548, 53.591874619411044],
            [27.537115106757483, 53.59438262430456],
            [27.53158922089858, 53.59554011465099],
            [27.52476312607388, 53.59573302698118],
            [27.517286927664372, 53.593610946634044],
            [27.512411145390104, 53.59283925433641],
            [27.506235155946513, 53.593225102247004],
            [27.499084009329408, 53.59476845812122],
            [27.493883175262738, 53.59746919511559],
            [27.49063265374656, 53.60113420500977],
            [27.491282758229545, 53.60749899270559],
            [27.495508436020884, 53.61019891585141],
            [27.501034321879786, 53.61116313239785],
            [27.504284842497782, 53.610584604685755],
            [27.506560207738744, 53.60904182714535],
            [27.511435989114887, 53.60884897558981],
            [27.51826208393959, 53.6086561236865],
            [27.521837657248113, 53.60884897558981],
            [27.52866375117469, 53.61077744831482],
            [27.532564377173742, 53.61232016297697],
            [27.535489845999336, 53.61482695362224],
            [27.53939047110015, 53.61849045745748],
            [27.5436161488916, 53.620804085862744],
            [27.544061511738505, 53.6208065873347],
            [27.54394120068389, 53.62099688228392],
            [27.541015731858295, 53.62523818501819],
            [27.537440158549714, 53.62755144304168],
            [27.531264168207997, 53.629864574798944],
            [27.52346291800626, 53.63179208711688],
            [27.520862500972896, 53.634490456863034],
            [27.521512605455882, 53.63853768817256],
            [27.526063335039623, 53.640657511416805],
            [27.53386458524119, 53.641428329577934],
            [27.53841531482493, 53.642391832869464],
            [27.54231594082421, 53.64451146242209],
            [27.54231594082421, 53.64663098544793],
            [27.53776521124047, 53.64971373796914],
            [27.528988803865218, 53.65086971192869],
            [27.52053744828237, 53.64913573910468],
            [27.511110937322485, 53.64720901864598],
            [27.50330968622262, 53.64720901864598],
            [27.49420822705514, 53.64740169444042],
            [27.48868234119618, 53.64875040194926],
            [27.487399169372452, 53.6511270765447],
            [27.481369948782287, 53.65130575271655],
            [27.474187959408255, 53.652724645167154],
            [27.467347969442528, 53.653332727846475],
            [27.45742998390267, 53.6539408012232],
            [27.44682799864762, 53.65211655424963],
            [27.43485801665696, 53.6490759670383],
            [27.429044024916664, 53.64644061448058],
            [27.42254603435947, 53.644007835125194],
            [27.420836037317372, 53.63812803863925],
            [27.422888033768004, 53.63488366193718],
            [27.427334027874338, 53.631233440026676],
            [27.430070023142036, 53.62677162904856],
            [27.4304120225504, 53.62332354264265],
            [27.434516017248427, 53.62109227794667],
            [27.43896201045652, 53.61622365472829],
            [27.43964600927353, 53.611963148115535],
            [27.43759401282273, 53.60993418455854],
            [27.432122020490965, 53.608919666486145],
            [27.424940031116932, 53.60851385243251],
            [27.419810038193646, 53.607702212092704],
            [27.413312047636452, 53.605064274452275],
            [27.40818205561152, 53.60100558685417],
            [27.40442006122015, 53.59694650923899],
            [27.403394062096595, 53.593090024182516],
            [27.40510406003716, 53.58801516522175],
            [27.405788058854057, 53.584563913012744],
            [27.407156056487793, 53.580909339370805],
            [27.411602050594183, 53.58009716856924],
            [27.416048043802448, 53.58030021259901],
            [27.419810038193646, 53.58050325565375],
            [27.422204034951108, 53.58030021259901],
            [27.424256032300036, 53.57664526977669],
            [27.424256032300036, 53.574208465853076],
            [27.42152003613421, 53.56974062713044],
            [27.418784039968273, 53.56669410245223],
            [27.40818205561152, 53.5634442348333],
            [27.40202606446269, 53.56060039522487],
            [27.39655407213087, 53.55613111873407],
            [27.390740080390742, 53.55227090893021],
            [27.384926089548742, 53.54617512386466],
            [27.376718101051154, 53.53967198488607],
            [27.371246109617687, 53.53642004127124],
            [27.36201212289467, 53.531541656699744],
            [27.34764814324825, 53.52666271061793],
            [27.335336161849227, 53.523816398724705],
            [27.3254181763092, 53.52198652594575],
            [27.32097218220281, 53.52178320192803],
            [27.31481619105415, 53.52279981279179],
            [27.31105419666295, 53.52625610649562],
            [27.30900220021215, 53.53296457699031],
            [27.309344199620682, 53.537842797637666],
            [27.31002819843758, 53.54251723125509],
            [27.306266204046153, 53.54515907405505],
            [27.30079421171456, 53.54475264751534],
            [27.294980219974263, 53.53987522356903],
            [27.294296221157367, 53.535607015938695],
            [27.291902224399905, 53.528898964052814],
            [27.291560224991372, 53.52442633910846],
            [27.291218225583066, 53.51995324132042],
            [27.287114231783335, 53.51832654378342],
            [27.280958240634675, 53.51751317105902],
            [27.273434251852052, 53.5164964338631],
            [27.261464268963266, 53.5164964338631],
            [27.253598280772337, 53.51751317105902],
            [27.24231229670022, 53.51547967173474],
            [27.238892301717385, 53.51344607481633],
            [27.23136831293499, 53.50998873591084],
            [27.22521232178633, 53.50897181816174],
            [27.221450327395132, 53.50998873591084],
            [27.21392633861251, 53.51303934382804],
            [27.20777034746385, 53.516089731619104],
            [27.206402349830114, 53.51995324132042],
            [27.20982234481278, 53.524223026800996],
            [27.214610337429406, 53.52666271061793],
            [27.219740330352863, 53.52808579484099],
            [27.223844324152367, 53.53174493387792],
            [27.2241863235609, 53.535403757299775],
            [27.220766328578236, 53.53865577950506],
            [27.214268338021043, 53.54028169694027],
            [27.207428348055316, 53.540484932162315],
            [27.20093035749835, 53.539468745761155],
            [27.195116365757997, 53.53621678653519],
            [27.188276375792498, 53.53337111671044],
            [27.18109438641841, 53.532354760092005],
            [27.17425439645291, 53.53174493387792],
            [27.16091641593016, 53.53174493387792],
            [27.153050426840935, 53.53194821061453],
            [27.14450043983311, 53.53459071298647],
            [27.140396446033378, 53.5372330504585],
            [27.13321445576105, 53.53967198488607],
            [27.127058465510686, 53.53967198488607],
            [27.123296470220964, 53.53520049768497],
            [27.122954470812658, 53.531135099416076],
            [27.123638469629498, 53.52666271061793],
            [27.12842646314442, 53.52198652594575],
            [27.126716465203856, 53.51893656267907],
            [27.121244473770332, 53.51507296026546],
            [27.117824478787668, 53.51405616397915],
            [27.108590492064536, 53.51344607481633],
            [27.10346049914125, 53.51507296026546],
            [27.097988507707782, 53.52015657465512],
            [27.096962508584056, 53.52279981279179],
            [27.090464518026863, 53.52706931083668],
            [27.083966527469897, 53.52727260948234],
            [27.07815253662784, 53.52483296079549],
            [27.07815253662784, 53.52015657465512],
            [27.080204533078472, 53.51486960306681],
            [27.083966527469897, 53.5112090055361],
            [27.08943851980166, 53.50592091744409],
            [27.094910512133424, 53.50083559560363],
            [27.096278509767217, 53.49391857819023],
            [27.090122518618557, 53.490866594534],
            [27.07917853485327, 53.48984921748297],
            [27.06891854990488, 53.48964573925099],
            [27.054212570850098, 53.49066312118316],
            [27.045662583842272, 53.49290127488746],
            [27.043952585901707, 53.49615656008871],
            [27.045662583842272, 53.50246296515758],
            [27.052160574399295, 53.5083616558004],
            [27.056264568199026, 53.512225869605686],
            [27.058316565547955, 53.51629308349595],
            [27.059342563773384, 53.52178320192803],
            [27.056948567015922, 53.52808579484099],
            [27.053870571441564, 53.532558033367366],
            [27.04532058443374, 53.53520049768497],
            [27.04019059151034, 53.536623295031745],
            [27.034376599770212, 53.53621678653519],
            [27.031640604502513, 53.532558033367366],
            [27.023774615413288, 53.52706931083668],
            [27.017276624856265, 53.523206450092516],
            [27.013514630464897, 53.524223026800996],
            [27.01043663489054, 53.528898964052814],
            [27.006332641090808, 53.5341841849754],
            [27.00051864935068, 53.53581027413577],
            [26.997782653184686, 53.533980919506234],
            [26.997782653184686, 53.52727260948234],
            [26.99744065377638, 53.523206450092516],
            [26.989916664993757, 53.52117322401983],
            [26.983760673845097, 53.52605280297087],
            [26.982050676803, 53.5313383785458],
            [26.980682678270796, 53.53702979962526],
            [26.976578684471235, 53.541704323539534],
            [26.972474690671504, 53.54231400578965],
            [26.966318699522844, 53.54028169694027],
            [26.961872705416283, 53.537639549197706],
            [26.957084712799656, 53.535607015938695],
            [26.955272473835635, 53.53464961517466],
          ],
        ],
      },
      properties: {
        shapeName: "Uzda",
        shapeISO: "",
        shapeID: "67162791B57084664446232",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
